import React, { Component } from "react";
import { Button, Container, Form, Spinner } from "react-bootstrap";
import { withRouter } from "next/router";
import InputMask from "react-input-mask";
import axios from "axios";

import xVerifyEmailService, { VALID_EMAIL_STATUSES, INVALID_EMAIL_STATUSES, VALIDATION_MESSAGE } from "../../../services/xVerifyEmailService";
import { checkEmail } from "../../../helpers/emailChecker";

import Names from "../../../component/form/Names";
import Fieldset from "../../../component/form/Fieldset";
import { config } from "../../../../_config";
import { getHostname } from "../../../helpers/common";

const { email } = config;
class ContactUs extends Component {
  state = {
    customerEmail: "",
    customerFirstName: "",
    customerLastName: "",
    customerMiddleName: "",
    customerPhone: null,
    validated: false,
    questionsOrder: "true",
    orderId: null,
    message: null,
    error: null,
    isSended: null,
    verifying: false,
    verificationResult: null,
    suspendedSubmit: false,
  };

  handleChange = (e) => {
    const { type, id, name, value } = e.target;
    if (type === "email") {
      this.setState({ [name || id]: value, verificationResult: null });
    } else {
      this.setState({ [name || id]: value });
    }
  };

  handleBlur = (e) => {
    const { type, value } = e.target;
    if (type === "email" && value) {
      if (!this.state.verificationResult && checkEmail(value)) {
        this.setState({ verifying: true });

        let emailValue = value;
        if (emailValue.indexOf("+") > -1 && emailValue.indexOf("gmail.com") > -1) {
          emailValue =
            emailValue.substring(0, emailValue.indexOf("+")) +
            emailValue.substring(emailValue.indexOf("@"), emailValue.length);
        }
        xVerifyEmailService(emailValue)
          .then(result => {
            this.setState({
              verificationResult: result,
              verifying: false,
            });
          });
      }
    }
  };

  handleKeyDown = (e) => {
    const { type, value } = e.target;
    if (type === "email" && value && e.code === "Enter") {
      if (!this.state.verificationResult && checkEmail(value)) {
        this.setState({ verifying: true, suspendedSubmit: true });

        let emailValue = value;
        if (emailValue.indexOf("+") > -1 && emailValue.indexOf("gmail.com") > -1) {
          emailValue =
            emailValue.substring(0, emailValue.indexOf("+")) +
            emailValue.substring(emailValue.indexOf("@"), emailValue.length);
        }
        xVerifyEmailService(emailValue)
          .then(result => {
            this.setState({
              verificationResult: result,
              verifying: false,
            });
          });
      }
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (this.state.verifying) {
      return;
    }

    this.setState({ suspendedSubmit: false });

    const form = e.currentTarget;
    const section = document.querySelector(".is-invalid");

    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      if (form.checkValidity() === false) {
        document.querySelector(".form-control:invalid")?.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        e.preventDefault();
        const contactus = {
          name:
            this.state.customerFirstName +
            " " +
            this.state.customerMiddleName +
            " " +
            this.state.customerLastName,
          email: this.state.customerEmail,
          message: this.state.message,
          orderId: this.state.orderId,
          phone: this.state.customerPhone,
          domain: getHostname(),
        };
        axios
          .post(
            process.env.NEXT_PUBLIC_REACT_APP_API + "/contact-us",
            contactus,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            this.setState({ isSended: true });
          })
          .catch((error) => {
            this.setState({ error: true });
          });
      }
    }

    this.setState({ validated: true });
  };

  componentDidUpdate(_, prevState) {
    if (prevState?.verifying && !this.state.verifying && this.state.suspendedSubmit) {
      document.getElementById("ContactUsSubmitButton")?.click();
    }
  }

  render() {
    const isEmailValid = this.state.verificationResult?.status && !this.state.verifying ? VALID_EMAIL_STATUSES.includes(this.state.verificationResult.status) : undefined;
    const isEmailInvalid = this.state.verificationResult?.status && !this.state.verifying ? INVALID_EMAIL_STATUSES.includes(this.state.verificationResult.status) : undefined;
    const invalidEmailMessage = VALIDATION_MESSAGE[this.state.verificationResult?.reason] || "You must provide a valid email address";

    if (this.state.error) {
      return (
        <div className="content">
          <h3>Contact Us</h3>
          <hr />
          <h2 style={{ textAlign: "center" }}>Error</h2>
        </div>
      );
    } else if (this.state.isSended) {
      return (
        <div className="home ">
          <div className="content">
            <h3>Contact Us</h3>
            <hr />
            <h2 style={{ textAlign: "center" }}>
              Thank you. Your request was received. You will hear from one of our experts within 1 business day.
            </h2>
          </div>
        </div>
      );
    } else {
      return (
        <div className="home ">
          <div className="content">
            <h3>Contact Us</h3>
            <hr />
            <Container fluid className="Form contact">
              <Form
                noValidate
                validated={this.state.validated}
                onSubmit={this.handleSubmit}
              >
                <Form.Group controlId="header">
                  <Form.Label className="mb-5">
                    Our support e-mail{" "}
                    <a href={`mailto:${email}?subject=Mail from Contact Us USA Taxid Site`}>
                      {email}
                    </a>
                    <br />
                    Our support phone is:{" "}
                    <a href="tel:1-800-317-5781"> 1-800-317-5781</a>
                  </Form.Label>
                </Form.Group>
                <Form.Group controlId="header">
                  <Form.Label className="mb-5">
                    If you have any questions about getting started or the order
                    you placed please fill out for the below.
                  </Form.Label>
                </Form.Group>
                <Names
                  id="customer"
                  onChange={this.handleChange}
                  state={this.state}
                />
                <Form.Group controlId="customerPhone">
                  <Form.Label>Phone Number</Form.Label>
                  <InputMask
                    mask="(999) 999-9999"
                    onChange={this.handleChange}
                    maskChar={null}
                  >
                    {(inputProps) => (
                      <Form.Control
                        required
                        type="phone"
                        placeholder="(123) 456-7890"
                        pattern=".{14,}"
                      />
                    )}
                  </InputMask>
                  <Form.Control.Feedback type="invalid">
                    You must provide a valid phone number
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="customerEmail">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    type="email"
                    required
                    placeholder="Enter email"
                    pattern="^([a-zA-Z0-9_\-\+\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$"
                    isValid={isEmailValid}
                    isInvalid={isEmailInvalid}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    onKeyDown={this.handleKeyDown}
                  />
                  {this.state.verifying && (
                    <Form.Control.Feedback type="processing">
                      Verification...
                    </Form.Control.Feedback>
                  )}
                  <Form.Control.Feedback type="invalid">
                    {invalidEmailMessage}
                  </Form.Control.Feedback>
                  {this.state.verifying && (
                    <Spinner
                      animation="border"
                      variant="secondary"
                      className="form-control-loader"
                    />
                  )}
                </Form.Group>
                <div className="radio">
                  <Fieldset
                    id="questionsOrder"
                    label="Have you placed and order with us?"
                    questionValue={this.state.questionsOrder}
                    onChange={this.handleChange}
                  />
                </div>
                {this.state.questionsOrder === "false" ? null : (
                  <>
                    <Form.Group controlId="orderId">
                      <Form.Label>Order number</Form.Label>
                      <Form.Control
                        type="text"
                        required
                        placeholder="Order Number"
                        onChange={this.handleChange}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter order number
                      </Form.Control.Feedback>
                    </Form.Group>
                  </>
                )}
                <Form.Group controlId="message">
                  <Form.Label>How can we help you?</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    required
                    placeholder="Type here..."
                    minLength="5"
                    maxLength="2147483647"
                    onChange={this.handleChange}
                  />
                  <Form.Control.Feedback type="invalid">
                    Message length must be longer than 5 characters
                  </Form.Control.Feedback>
                </Form.Group>

                <Button
                  id="ContactUsSubmitButton"
                  variant="primary"
                  type="submit"
                  className="mt-4"
                  onMouseDown={() => this.handleChange({ target: { id: "suspendedSubmit", value: true } })}
                >
                  Submit
                </Button>
              </Form>
            </Container>
          </div>
        </div>
      );
    }
  }
}

export default withRouter(ContactUs);
